import { IconName } from 'components/Icon';
import { routes } from 'config/routes';

export const AVERAGE_TIME_PER_COMMIT = 90; // seconds

export const HEADER_NAVIGATION_LINKS = [
	{
		label: 'Planos',
		to: routes.get('pricing'),
	},
	{
		label: 'Segurança & privacidade',
		to: routes.get('privacy'),
	},
	{
		label: 'Documentação',
		to: routes.get('docs'),
	},
];

export const BENEFITS = [
	{
		title: 'Privacidade garantida',
		icon: 'ShieldCheck',
		description:
			'Garantimos a não retenção do código analisado, assegurando a máxima privacidade dos dados.',
	},
	{
		title: 'Proteção de dados',
		icon: 'LockKeyhole',
		description:
			'Asseguramos a confidencialidade absoluta, sem compartilhamento de dados com terceiros.',
	},
	{
		title: 'Geração instantânea',
		icon: 'Clock',
		description:
			'As métricas e análises são gerados em tempo de execução, não sendo necessário armazenar seu código.',
	},
	{
		title: 'Transparência total',
		icon: 'Eye',
		description:
			'O processo de análise é completamente transparente, com a CLI sendo open-source para auditoria.',
	},
	{
		title: 'Segurança integrada',
		icon: 'KeyRound',
		description:
			'Implementamos autenticação robusta em todas as etapas, garantindo a segurança do código.',
	},
	{
		title: 'Controle total',
		icon: 'Wrench',
		description:
			'Você mantém controle absoluto sobre os dados enviados para a API, preservando a autonomia.',
	},
] satisfies { title: string; icon: IconName; description: string }[];

export const WHATSAPP_NUMBER = '5573998532739';

/**
 * When update the `links` object, remember of update/check if `next.config.js` is alright.
 * Some of bellow links is used in the next rewrites feature.
 */

export const contacts = {
	email: 'contato@giteai.dev',
	phone: 73998532739,
};

export const social = {
	whatsapp: `https://api.whatsapp.com/send/?phone=55${contacts.phone}`,
	instagram: `https://instagram.com/giteai.dev`,
	x: `https://x.com/giteai`,
};

export const resources = {
	privacy: routes.get('privacy'),
	docs: routes.get('docs'),
};
